import { render, staticRenderFns } from "./AprovalPenerimaDana.vue?vue&type=template&id=47c83113&scoped=true"
import script from "./AprovalPenerimaDana.vue?vue&type=script&lang=js"
export * from "./AprovalPenerimaDana.vue?vue&type=script&lang=js"
import style0 from "./AprovalPenerimaDana.vue?vue&type=style&index=0&id=47c83113&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c83113",
  null
  
)

export default component.exports